import React from "react";
import { cn } from "@/lib/utils";

export const BrowserFrame = ({ title = "app.d20.finance", className, children, ...rest }) => (
  <div className={cn("overflow-hidden rounded-xl border border-white/10 bg-[#0b0d14] shadow-[0_30px_80px_-20px_rgba(0,0,0,0.8)]", className)} {...rest}>
    <div className="flex items-center gap-1.5 border-b border-white/10 bg-white/[0.03] px-3 py-2">
      <span className="h-2.5 w-2.5 rounded-full bg-red-500/70" /><span className="h-2.5 w-2.5 rounded-full bg-amber-500/70" /><span className="h-2.5 w-2.5 rounded-full bg-emerald-500/70" />
      <span className="ml-3 flex-1 truncate rounded-md bg-white/5 px-3 py-0.5 text-center text-[11px] font-mono text-white/40">{title}</span>
    </div>
    {children}
  </div>
);
